import TextNavBackground from "../components/common/TextNavBackground";
import { apiWrapper } from "../utils/api/apiWrapper";
import { kContactUsURL } from "../utils/constants/apiUrls";
import { THREE_MONTH_REFRESH_INTERVAL_SECONDS } from "../utils/constants/numbers";
import MarkdownRender from "../components/common/MarkdownRender";
import { customStaticSeoConfig, getApiToken } from "../utils/helpers/helpers";
import { CONTACT_US_URL } from "../utils/constants/websiteUrls";
import { TabNoData } from "../components/common/NoData";

const ContactUs = ({ contactUs }) => {
  // SAFE FIX: Use an empty object fallback (|| {}) to prevent destructuring from crashing
  const { contact_us: contactUsInfo = "" } = contactUs || {};

  const url = CONTACT_US_URL;

  return (
    <>
      {customStaticSeoConfig("Contact Us")}
      <TextNavBackground title="Contact us" />

      {contactUsInfo === "" && <TabNoData />}

      {contactUsInfo !== "" && (
        <MarkdownRender
          title={"Asante Kotoko SC Contacts"}
          caption={
            "All the essential numbers and email addresses you need to get in touch with us at Asante Kotoko SC."
          }
          url={url}
          markdownData={contactUsInfo}
        />
      )}
    </>
  );
};

export default ContactUs;

export const getStaticProps = async (context) => {
  const token = getApiToken();
  const contactUs = await apiWrapper.get(kContactUsURL, token);

  return {
    props: {
      // SAFE FIX: Pass the raw wrapper object or a fallback object down to the props layer
      contactUs: contactUs?.data || {},
    },
    revalidate: THREE_MONTH_REFRESH_INTERVAL_SECONDS,
  };
};
